import * as React from 'react'

function SvgExit(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M16.426 7.083a.796.796 0 00-.474.148.761.761 0 00-.175 1.08l2.88 2.918h-8.25a.781.781 0 00-.79.773c0 .426.353.772.79.772h8.25l-2.88 2.917a.762.762 0 00.175 1.08.8.8 0 001.103-.17l3.785-4.134a.758.758 0 00-.008-.942l-3.777-4.124a.794.794 0 00-.63-.318z"
        fill={props.color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.8 3.773c0-.541.447-.973.99-.973h10.576c.543 0 .99.432.99.973a.982.982 0 01-.99.972H4.78v14.51h9.586c.543 0 .99.431.99.972a.982.982 0 01-.99.973H3.79a.981.981 0 01-.99-.973V3.773zm13.036 3.295a.996.996 0 01.592-.185.994.994 0 01.78.39l3.78 4.127a.959.959 0 01.01 1.19l-.005.006-3.784 4.132a.993.993 0 01-.793.39 1 1 0 01-.58-.184.962.962 0 01-.22-1.362l.009-.011 2.554-2.587h-7.772a.981.981 0 01-.99-.972c0-.541.447-.973.99-.973h7.772L15.625 8.44l-.009-.012a.961.961 0 01.22-1.361zm.587.215a.595.595 0 00-.355.11.562.562 0 00-.138.788l3.206 3.248h-8.729c-.33 0-.59.26-.59.573 0 .312.26.572.59.572h8.729l-3.206 3.247a.562.562 0 00.137.787.6.6 0 00.827-.126l.006-.009 3.787-4.134a.558.558 0 00-.007-.684L16.9 7.53l-.006-.009a.594.594 0 00-.47-.237z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgExit)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
